import { type FinalReservationType } from 'types/Reservation';
import { get, post } from './utils';

const post_reservation = async (
    reservation: FinalReservationType,
    callback: ((data: any) => void) | null = null
): Promise<void> => {
    const path = `/reservation/register`;
    const result = await post(path, reservation);
    console.debug('post_reservation', result);
    if (callback !== null) {
        callback(result?.data);
    } else return result?.data;
};

const cancel_reservaton = async (
    reservationId: string,
    callback: ((data: any) => void) | null = null
): Promise<void> => {
    const path = `/reservation/cancel`;
    const param = {
        reservation_id: reservationId,
    };
    const result = await post(path, param);
    console.debug('cancel_reservaton', result);
    if (callback !== null) {
        callback(result?.data);
    } else return result?.data;
};

const retrieve_reservation = async (
    reservationId: string,
    callback: ((data: any) => void) | null = null
): Promise<void> => {
    const path = '/reservation/retrieve?reservation_id=' + reservationId;
    const result = await get(path);
    console.debug('retrieve_reservation', result?.data);
    if (callback !== null) {
        callback(result?.data);
    } else return result?.data;
};

export { post_reservation, cancel_reservaton, retrieve_reservation };
